<template>
  <div
    class="split-image-section"
    :class="[`bg-${section.bg_color} style-${section.style}`, { 'has-quiz-image': section.show_quiz_button }]"
  >
    <div
      class="bg-image-holder"
      :style="{ backgroundImage: `url(${section.img.url})` }"
      @click="onImageClick"
    />
    <div :class="`bg dir-${section.img_side}`">
      <div class="orange" />

      <div
        class="img"
        @click="onImageClick"
      >
        <div
          class="aspect"
          :class="`ratio-${section.aspect_ratio}`"
        >
          <img
            loading="lazy"
            :src="section.img.url"
            :alt="section.img.alt"
            :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
          >
        </div>
      </div>
    </div>

    <!-- Conditionally wrap content with inner container when bg-grey -->
    <div
      class="container"
      :class="{ 'has-inner-container': hasBgGrey }"
    >
      <div
        v-if="hasBgGrey"
        class="container"
      >
        <h2 v-html="stripBlockTags(section.header)" />

        <div
          v-if="!section.video && !section.link"
          :class="`image-container dir-${section.img_side}`"
          @click="onImageClick"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <img
              loading="lazy"
              :src="section.img.url"
              :alt="section.img.alt"
              :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
            >
          </div>
        </div>

        <a
          v-if="section.link && section.link.url && section.img.url && !section.image_opens_video_player"
          :href="section.link.url"
          :target="section.link.target"
          :class="`image-container dir-${section.img_side}`"
          @click="onImageClick"
          @keydown.enter="onImageClick"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <img
              loading="lazy"
              :src="section.img.url"
              :alt="section.img.alt"
              :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
            >
          </div>
        </a>

        <a
          v-if="section.link && section.link.url && section.img.url && section.image_opens_video_player"
          :href="section.link.url"
          :target="section.link.target"
          :class="`image-container dir-${section.img_side}`"
          @click="onVideoClick($event, section)"
          @keydown.enter="onVideoClick($event, section)"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <img
              loading="lazy"
              :src="section.img.url"
              :alt="section.img.alt"
              :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
            >
          </div>
        </a>

        <div
          v-if="section.video"
          :class="`image-container dir-${section.img_side}`"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <video
              width="530"
              height="530"
              autoplay
              loop
              muted
              playsinline
              style="width: 100%; height: 100%; object-fit: cover;"
            >
              <source
                :src="section.video"
                type="video/mp4"
              >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <!-- <div
          v-if="section.gif.url"
          :class="`image-container dir-${section.img_side}`"
        >
          <div class="aspect">
            <video
              width="530"
              height="530"
              autoplay
              loop
              muted
            >
              <track
                default
                kind="captions"
                srclang="en"
                src="SUBTITLE_PATH"
              >
              <source
                :src="section.gif.url"
                type="video/mp4"
              >
              Your browser does not support the video tag.
            </video>
          </div>
        </div> -->

        <div
          class="content"
          v-html="section.content"
        />

        <div
          v-if="hasLink || section.show_quiz_button"
          class="button-holder"
        >
          <a
            v-if="hasLink"
            :href="section.link.url"
            :target="section.link.target"
            class="link btn ghost"
            :class="btnClass"
            @click="onLinkClick($event, section)"
            @keydown.enter="onLinkClick($event, section)"
          >
            {{ section.link.title }}
          </a>
          <a
            v-if="section.link_2 && section.link_2.url"
            :href="section.link_2.url"
            :target="section.link_2.target"
            class="link btn"
            :class="btnClass"
            style="margin-top: 10px;"
            @click="onLinkClick($event, section)"
            @keydown.enter="onLinkClick($event, section)"
          >
            {{ section.link_2.title }}
          </a>
          <RysQuizDiscoverButton
            v-if="section.show_quiz_button"
            class="btn ghost"
            :class="btnClass"
            :style="hasLink ? 'margin-top: 10px;' : null"
          >
            {{ section.quiz_button_text || 'Discover Now' }}
          </RysQuizDiscoverButton>
        </div>
      </div>

      <!-- Fallback content when not bg-grey (original structure) -->
      <template v-else>
        <h2 v-html="stripBlockTags(section.header)" />

        <div
          v-if="!section.video && !section.link"
          :class="`image-container dir-${section.img_side}`"
          @click="onImageClick"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <img
              loading="lazy"
              :src="section.img.url"
              :alt="section.img.alt"
              :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
            >
          </div>
        </div>

        <a
          v-if="section.link && section.link.url && section.img.url && !section.image_opens_video_player"
          :href="section.link.url"
          :target="section.link.target"
          :class="`image-container dir-${section.img_side}`"
          @click="onImageClick"
          @keydown.enter="onImageClick"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <img
              loading="lazy"
              :src="section.img.url"
              :alt="section.img.alt"
              :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
            >
          </div>
        </a>

        <a
          v-if="section.link && section.link.url && section.img.url && section.image_opens_video_player"
          :href="section.link.url"
          :target="section.link.target"
          :class="`image-container dir-${section.img_side}`"
          @click="onVideoClick($event, section)"
          @keydown.enter="onVideoClick($event, section)"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <img
              loading="lazy"
              :src="section.img.url"
              :alt="section.img.alt"
              :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
            >
          </div>
        </a>

        <div
          v-if="section.video"
          :class="`image-container dir-${section.img_side}`"
        >
          <div
            class="aspect"
            :class="`ratio-${section.aspect_ratio}`"
          >
            <video
              width="530"
              height="530"
              autoplay
              loop
              muted
              playsinline
              style="width: 100%; height: 100%; object-fit: cover;"
            >
              <source
                :src="section.video"
                type="video/mp4"
              >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <!-- <div
          v-if="section.gif.url"
          :class="`image-container dir-${section.img_side}`"
        >
          <div class="aspect">
            <video
              width="530"
              height="530"
              autoplay
              loop
              muted
            >
              <track
                default
                kind="captions"
                srclang="en"
                src="SUBTITLE_PATH"
              >
              <source
                :src="section.gif.url"
                type="video/mp4"
              >
              Your browser does not support the video tag.
            </video>
          </div>
        </div> -->

        <div
          class="content"
          v-html="section.content"
        />

        <div
          v-if="hasLink || section.show_quiz_button"
          class="button-holder"
        >
          <a
            v-if="hasLink"
            :href="section.link.url"
            :target="section.link.target"
            class="link btn ghost"
            :class="btnClass"
            @click="onLinkClick($event, section)"
            @keydown.enter="onLinkClick($event, section)"
          >
            {{ section.link.title }}
          </a>
          <a
            v-if="section.link_2 && section.link_2.url"
            :href="section.link_2.url"
            :target="section.link_2.target"
            class="link btn"
            :class="btnClass"
            style="margin-top: 10px;"
            @click="onLinkClick($event, section)"
            @keydown.enter="onLinkClick($event, section)"
          >
            {{ section.link_2.title }}
          </a>
          <RysQuizDiscoverButton
            v-if="section.show_quiz_button"
            class="btn ghost"
            :class="btnClass"
            :style="hasLink ? 'margin-top: 10px;' : null"
          >
            {{ section.quiz_button_text || 'Discover Now' }}
          </RysQuizDiscoverButton>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import RysEmbedModal from '@/components/modals/EmbedModal.vue';
import QuizDiscover from '@/components/QuizDiscover.vue';
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'SplitImageSection',

  props: {
    section: { type: Object, required: true }
  },

  setup() {
    const modal = useModal();
    return { modal };
  },

  data() {
    return {
      screenWidth: 0
    };
  },

  computed: {
    btnClass() {
      if (this.section.link) {
        if (this.section.style === 'fancy') {
          return 'black';
        }

        if (this.section.bg_color === 'white') {
          return 'ghost';
        }
      }

      return '';
    },

    imgXPos() {
      if (this.screenWidth >= 1170) {
        return this.section.img_x_pos;
      }
      return this.section.mob_img_x_pos;
    },

    imgYPos() {
      if (this.screenWidth >= 1170) {
        return this.section.img_y_pos;
      }
      return this.section.mob_img_y_pos;
    },

    hasLink() {
      return !!(this.section.link && this.section.link.url);
    },

    hasBgGrey() {
      return this.section.bg_color === 'grey';
    }
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  },

  methods: {
    stripBlockTags,

    showEmbedModal(html) {
      this.modal(RysEmbedModal, this, { props: { embed: html } });
    },

    onLinkClick(e, section) {
      if (section.link_shows_video && section.video) {
        e.preventDefault();
        this.showEmbedModal(section.video);
      }
    },

    // When the section has a quiz button, the image opens the quiz too (overriding its link).
    onImageClick(e) {
      if (this.section.show_quiz_button) {
        e.preventDefault();
        this.modal(QuizDiscover, this);
        return;
      }
      this.onLinkClick(e, this.section);
    },

    onVideoClick(e, section) {
      if (section.video) {
        e.preventDefault();
        this.showEmbedModal(section.video);
      }
    },

    onWindowResize() {
      this.screenWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
@use 'sass:math';

div.split-image-section {
  position: relative;
  overflow-x: clip;

  .bg {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .orange {
      position: relative;
      background-color: $thd-orange;
      height: 100%;
      width: 100%;
      transform: rotateZ(2deg) scale(110%);
      z-index: 2;

      @media screen and (min-width: $breakpoint-lg) {
        width: 50%;
        transform: rotateZ(2deg) scale(105%);
      }
    }

    .img {
      height: 100%;
      padding-top: 0;
      position: absolute;
      right: 0;
      width: 50%;
      z-index: 1;

      img {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }

  .container {
    position: relative;
    z-index: 2;
    display: grid;
    gap: 24px;
    grid-template-columns: minmax(auto, 100%);
    grid-template-rows: repeat(4, minmax(0, auto));

    @media screen and (min-width: $breakpoint-lg) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-template-rows: repeat(2, auto) minmax(0, 1fr);
      grid-auto-flow: column dense;
      gap: 24px 60px;
    }

    .image-container,
    .video-container {
      cursor: pointer;
      order: 1;

      @media screen and (min-width: $breakpoint-lg) {
        order: 9999;
        grid-row: span 3 / span 3;

        &.dir-left {
          order: -9999;
        }
      }

      .aspect {
        position: relative;
        width: 100%;
        padding-top: math.div(9, 16) * 100%;

        @media screen and (min-width: $breakpoint-lg) {
          padding-top: 100%;
        }

        &.ratio-landscape {
          padding-top: math.div(9, 16) * 100%;
        }

        > img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border: 2px solid #f96302;

          &.clickable {
            cursor: pointer;
          }
        }

        > video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .embed::v-deep {
        width: 100%;
        height: 0;
        overflow: hidden;
        position: relative;
        padding-top: math.div(9, 16) * 100%;

        iframe {
          width: 100% !important;
          height: 100% !important;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }

  &.bg-white {
    background-color: $thd-white;

    h2 {
      color: $thd-black;
    }

    .content {
      color: $thd-black;
    }

    .button-holder {
      order: 2;

      @media screen and (min-width: $breakpoint-lg) {
        order: 0;
      }
    }
  }

  &.bg-black {
    background-color: $thd-black;

    h2 {
      color: $thd-white;
    }

    .content {
      color: $thd-white;
    }
  }

  &.bg-grey {
    background-color: #f5f5f5;
    padding: 15px 0;
    margin-top: 60px;

    @media screen and (min-width: $breakpoint-lg) {
      margin-top: 0;
    }

    .bg-image-holder {
      background-size: cover;
      background-position: center;
      position: absolute;
      top: unset;
      bottom: 0;
      right: 0;
      height: 380px;
      width: 100%;

      @media screen and (min-width: $breakpoint-lg) {
        top: 0;
        height: 100%;
        width: 47%;
      }
    }

    .container.has-inner-container {
      border: 2px solid #ffffff;
      padding: 60px 0 330px;
      margin: auto;

      @media screen and (min-width: $breakpoint-lg) {
        margin: 0 auto;
        max-width: 98%;
        padding: 0;
        display: block;
      }

      .container {
        display: grid;
      }

      .image-container {
        display: none;
      }
    }

    h2 {
      color: $thd-black;
      padding-left: 20px;
      padding-right: 20px;

      @media screen and (min-width: $breakpoint-lg) {
        padding-left: 30px;
        padding-right: 0;
      }
    }

    .content {
      color: $thd-black;
      padding-left: 20px;
      padding-right: 20px;

      @media screen and (min-width: $breakpoint-lg) {
        padding-left: 30px;
        padding-right: 0;
      }
    }

    .button-holder {
      padding-left: 20px;
      padding-right: 20px;

      @media screen and (min-width: $breakpoint-lg) {
        padding-left: 30px;
        padding-right: 0;
      }
    }
  }

  // In the grey and fancy layouts the visible image is a background behind the content
  // container, so let clicks fall through the container's empty space to reach it.
  &.has-quiz-image {
    .bg-image-holder,
    .bg .img,
    .image-container {
      cursor: pointer;
    }

    .container {
      pointer-events: none;

      > :not(.container) {
        pointer-events: auto;
      }
    }
  }

  &.style-fancy {
    margin-top: 64px;

    @media screen and (min-width: $breakpoint-lg) {
      margin-top: 0;
    }

    .bg {
      display: flex;

      &.dir-left {
        flex-direction: row-reverse;

        .orange {
          transform: rotateZ(-2deg) scale(110%);

          @media screen and (min-width: $breakpoint-lg) {
            transform: rotateZ(-2deg) scale(105%);
          }
        }

        .img {
          left: 0;
          right: unset;
        }
      }
    }

    .container::v-deep {
      padding-top: 32px;

      @media screen and (min-width: $breakpoint-lg) {
        padding-top: 60px;
      }

      h2 {
        color: $thd-white;
      }

      .content {
        color: $thd-white;

        strong,
        b {
          color: $thd-black;
        }
      }

      .button-holder {
        .btn.ghost.black {
          background: #040404;
          border: 3px solid #040404;
          color: #ffffff;

          &:hover {
            background: #ffffff;
            border: 3px solid #ffffff;
            color: #040404;
          }
        }
      }

      .image-container {
        @media screen and (min-width: $breakpoint-lg) {
          visibility: hidden;
        }
      }
    }
  }
}
</style>
